import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m11.438 6.018-.563-.618-.197-.215a5.33 5.33 0 0 0-4.866-1.638C3.314 3.991 1.5 6.114 1.5 8.594v.16a5.25 5.25 0 0 0 1.74 3.894l8.62 7.837a.224.224 0 0 0 .14.055.201.201 0 0 0 .14-.055l8.626-7.837A5.263 5.263 0 0 0 22.5 8.754v-.16c0-2.48-1.814-4.603-4.313-5.047a5.33 5.33 0 0 0-4.865 1.638l-.197.215-.563.618a.761.761 0 0 1-1.124 0Zm1.635-2.613a6.908 6.908 0 0 1 5.382-1.3C21.665 2.679 24 5.41 24 8.595v.16a6.688 6.688 0 0 1-2.217 4.964l-8.625 7.838A1.713 1.713 0 0 1 12 22c-.431 0-.844-.16-1.162-.444l-8.625-7.833A6.726 6.726 0 0 1 0 8.754v-.16c0-3.185 2.334-5.916 5.545-6.488a6.883 6.883 0 0 1 5.377 1.3c.314.242.61.507.876.805l.197.215.197-.215a6.35 6.35 0 0 1 .624-.6l.253-.206h.004Z"
    }, null, -1)
  ])))
}
export default { render: render }